import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/service/api-service/api-service';

@Injectable({ providedIn: 'root' })
export class CommuniquesService {
  constructor(private api: ApiService) {}

  getCommuniques(page: number, limit = 8, search = '', status = ''): Observable<any> {
    return this.api.post('/api/communication/communiques/list', {
      page,
      limit,
      search: search || null,
      status: status || null,
    });
  }

  getCommuniqueById(id: number): Observable<any> {
    return this.api.get(`/api/communication/communiques/${id}`);
  }

  createCommunique(data: FormData | any): Observable<any> {
    return this.api.post('/api/communication/communiques', data);
  }

  updateCommunique(id: number, data: FormData | any): Observable<any> {
    return this.api.put(`/api/communication/communiques/${id}`, data);
  }

  setStatus(id: number, status: 'ACTI' | 'INAC' | 'ARCH'): Observable<any> {
    return this.api.patch(`/api/communication/communiques/${id}/status`, { status });
  }

  deleteCommunique(id: number): Observable<any> {
    return this.api.delete(`/api/communication/communiques/${id}`);
  }
}
